"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorCodesMap = new Map([
    [0, 'None'],
    [1, 'Bad state'],
    [2, 'VBATT low'],
    [3, 'VBATT high'],
    [4, 'VBATT Load Low'],
    [5, 'VUSB High'],
    [6, 'VCART Low'],
    [7, 'VCART High'],
    [8, 'VDCDC Low'],
    [9, 'VDCDC High'],
    [10, 'ICART Low'],
    [11, 'ICART High'],
    [12, 'Temp Low'],
    [13, 'Temp High'],
    [14, 'Failed Charge'],
    [15, 'Coarse Vape Abuse'],
    [16, 'BLE Pairing Disallowed'],
    [17, 'Vape Too Long'],
    [18, 'External Flash Failed'],
    [19, 'Charge IC Failed'],
    [20, 'Fuel Gauge Failed'],
    [21, 'Pressure Sensor Failed'],
    [22, 'FOTA Failed due to LowB attery'],
]);
exports.default = ErrorCodesMap;
